module.exports = __webpack_public_path__ + "img/3.977104c0.png";